import { TabType } from "@hooks/useTabs";
import AnnualReportPage from "@sca/components/Awards/AnnualReportPage";
import ChiefExecutiveOfficerPage from "@sca/components/Awards/ChiefExecutiveOfficerPage";
import ChiefFinancialOfficerPage from "@sca/components/Awards/ChiefFinancialofficerPage";
import GovernanceAwardPage from "@sca/components/Awards/GovernanceAwardPage";
import InvestorRelationsPage from "@sca/components/Awards/InvestorRelationsPage";
import ManagedBoardPage from "@sca/components/Awards/ManagedBoardPage";
import RiskManagementPage from "@sca/components/Awards/RiskManagementPage";
import SpecialEditionPage from "@sca/components/Awards/SpecialEditionPage";
import SpecialRecognitionAwardPage from "@sca/components/Awards/SpecialRecognitionAwardPage";

/**
 * Returns the corresponding static component to render based on the provided active tab identifier.
 *
 * This function is typically used to dynamically render different sections of the
 * Singapore Business Awards (SCA) Awards pages.
 *
 * @param page - The string identifier of the active tab.
 * @returns The React component corresponding to the given page, or `undefined` if not matched.
 */
export const SCAAwardsTabFactory = (tab: TabType) => {
  switch (tab) {
    case "best-managed-board":
      return ManagedBoardPage;

    case "best-chief-executive-officer":
      return ChiefExecutiveOfficerPage;

    case "best-chief-financial-officer":
      return ChiefFinancialOfficerPage;

    case "best-risk-management":
      return RiskManagementPage;

    case "best-investors-relations":
      return InvestorRelationsPage;

    case "best-annual-report":
      return AnnualReportPage;

    case "special-recognition-award":
      return SpecialRecognitionAwardPage;

    case "distinguished-distribution":
      return GovernanceAwardPage;

    case "special-edition":
      return SpecialEditionPage;
  }
};
